import ApiRouteData from './ApiRoutes.json';

// Define the type for API routes
type ApiRoutesType = typeof ApiRouteData;

/**
 * Gets the full API route with base URL and parameters
 * @param api - The API route key
 * @param urlParams - Optional URL parameters
 * @returns The complete API URL
 */
export function apiRoute(api: keyof ApiRoutesType, urlParams?: any[]): string {
  let route: string = ApiRouteData[api];

  if (urlParams && urlParams.length > 0) {
    urlParams.forEach((param, index) => {
      route = route.replace(`$${index}`, encodeURIComponent(param));
    });
  }

  let baseUrl = import.meta.env.VITE_BACKEND_APP_BASE_URL;

  if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }

  return `${baseUrl}${route}`;
}
